export default "__VITE_ASSET__DmfzWKEf__"